import React from 'react';
import classNames from 'classnames/bind';
import { bool } from 'prop-types';
import {
  Card, CardContent, CardTitle, Image, Col
} from '@thd-olt-component-react/core-ui';
import styles from './recent-order-details.module.scss';

const RecentOrderFallback = ({ isError }) => {
  let headerMessage = 'No Recent Orders';
  let subheaderMessage = 'Looks like you haven\'t placed any orders lately';

  if (isError) {
    headerMessage = 'Hmm, we couldn\'t load your order';
    subheaderMessage = 'Try refreshing the page or check back later.';
  }

  return (
    <Card>
      <CardTitle
        title="Your Latest Order"
        action={{ href: '/order/view/summary/' }}
        className="card__title u-width-100"
      />
      <CardContent className="u-width-100">
        <Col className={classNames(styles['recent-order-details__fallback-column'])} data-type="container">
          <div className={classNames(styles['recent-order-details__fallback-container'])} data-type="container">
            <div className={classNames(styles['recent-order-details__fallback-image-container'])}>
              <Image
                className={classNames(styles['recent-order-details__fallback-card-image'])}
                src="https://assets.thdstatic.com/images/v1/order.svg"
                alt="Order Icon"
                height="300"
                width="300"
              />
            </div>
            <p className={classNames(styles['recent-order-details__fallback-card-header'])}>{headerMessage}</p>
            {/* eslint-disable-next-line max-len */}
            <p className={classNames(styles['recent-order-details__fallback-card-subheader'])}>{subheaderMessage}</p>
            <a href="/order/view/summary" className="u__default-link">View All Orders</a>
          </div>
        </Col>
      </CardContent>
    </Card>

  );
};

RecentOrderFallback.propTypes = {
  isError: bool
};

RecentOrderFallback.defaultProps = {
  isError: false
};

export { RecentOrderFallback };